export default [
    {
        path: '/clients',
        name: 'clients',
        component: () => import('../../pages/clients/IndexPage.vue'),
        meta: {
            title: 'Clients',
            requiresAuth: true,
        },
    },
    {
        path: '/clients/:id',
        name: 'clients-detail',
        component: () => import('../../pages/clients/IndexPage.vue'),
        meta: {
            title: 'Client Detail',
            requiresAuth: true,
        },
    },
]
